<template>
  <div>
    <p :class="data.chi.class">{{ data.chi.name }}</p>
    <div class="can-tang">
      <div
        v-for="(item, key) in data.chi.cantangchi"
        :key="key"
        class="item"
      >
        <p :class="item.css">
          {{ item.tenCan }}
        </p>
        <p :class="item.css">
          {{ item.thapThan }}
        </p>
        <p :class="item.css">
          {{ item.truongSinh }} <br/>
          <span v-if="item.truongSinhDong">({{ item.truongSinhDong }})</span>
        </p>
        <p :class="item.css">
          ({{item.dovuong}})
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemChi',
  props: {
    data: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
</style>
